import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { ItemsType } from "../../../../../common-deprecated/redux/typeHelpers";

export const getInitialStateCarConfigItems = (): ItemsType => ({
    initialized: false,
    colours: [],
    wheels: [],
    upholsteries: [],
    packs: [],
    financePacks: [],
    extras: [],
    equipmentUpholsteries: [],
    wheelExtras: [],
    promotions: [],
    disclaimerPromotions: [],
    filterCarOptions: [],
    winterWheels: [],
    serviceProducts: [],
    tyres: [],
});

export type CarConfigItemActionTypes = ReturnType<typeof initCarConfigItems | typeof setMonthlyPrices>;

export const CarConfigItemSlice = createSlice({
    name: "items",
    initialState: getInitialStateCarConfigItems,
    reducers: {
        initCarConfigItems(state, action: PayloadAction<ItemsType>) {
            return {
                ...state,
                ...action.payload,
                initialized: true,
            };
        },
        setMonthlyPrices(state, action: PayloadAction<Record<string, string>>) {
            const { colours, extras, packs, upholsteries, wheels, winterWheels } = state;
            // Apply monthly rates for items
            [...colours, ...extras, ...packs, ...upholsteries, ...wheels, ...winterWheels].map((item) => {
                if (item.price) {
                    item.price.monthly = Number(action.payload[item.id] ?? 0);
                }

                return item;
            });
            return state;
        },
    },
});

export const { initCarConfigItems, setMonthlyPrices } = CarConfigItemSlice.actions;
